import styled from "styled-components";

export default styled.div`

&{
  width: 100%;
  height: 100%;
}

.imagePreview{
  width: auto;
  height: auto;
  max-width: 150px;
  min-width: 75px;  
  max-height: 100px;
  min-height: 50px;
}
`
